export default __webpack_public_path__ + "static/media/turtle.a6423925.svg";